export const COMMON_NAMESPACE = "common";
export const MENU_NAMESPACE = "menu";
export const LANGUAGE_MODAL_NAMESPACE = "languageModal";
export const ABOUT_MODAL_NAMESPACE = "aboutModal";
export const BILLER_LOGO_NAMESPACE = "billerLogo";
export const VALIDATE_NAMESPACE = "validate";
export const BILL_MODAL_NAMESPACE = "billModal";
export const HELP_MODAL_NAMESPACE = "helpModal";
export const BALANCE_NAMESPACE = "balance";
export const CONTACT_TOC_FOOTER = "contactAndTocFooter";
export const DONATION = "donation";
export const BANK_ACCCOUNT_MODAL = "bankAccountModal";
export const PAYABLE_DETAILS_NAMESPACE = "payableDetails";
export const CREDIT_DEBIT_MODAL = "creditDebitModal";
export const CASH_MODAL = "cashModal";
export const BARCODE_VIEW = "barcodeView";
export const EMAIL_VIEW = "emailView";
export const SMS_VIEW = "smsView";
export const RETAILER_VIEW = "retailerView";
export const PAYMENT_AMOUNT_MODAL_NAMESPACE = "paymentAmountModal";
export const PAYMENT_METHOD_MODAL_NAMESPACE = "paymentMethodModal";
export const REVIEW_CHARGES_MODAL_NAMESPACE = "reviewChargesModal";
export const RECEIPT_INFO_MODAL_NAMESPACE = "receiptInfoModal";
export const PAYMENT_RECEIPT_NAMESPACE = "paymentReceipt";
export const PAYSLIP_NAMESPACE = "payslipView";
export const MANAGE_PAYMENT_METHODS_MODAL = "managePaymentMethodsModal"
export const PAYMENT_DATE_MODAL = "paymentDateModal";
export const UNSUBSCRIBE_ALERTS = "unsubscribeAlerts";
export const LINK_EXPIRED_NAMESPACE = "linkExpired";
export const RECENT_PAYMENTS_NAMESPACE = "recentPayments"
export const SESSION_TIMEOUT = "sessionTimeout";
export const LOOKUP_NAMESPACE = "lookup";
export const FREEFORM_NAMESPACE = "freeform";
export const ORDER_NAMESPACE = "order";
export const LOOKUP_INFO_IMAGE_MODAL_NAMESPACE = "lookupInfoImageModal";
export const PAYABLE_SELECT = "payableSelect";
export const SELECT_PAYMENT_METHOD_MODAL_NAMESPACE = "selectPaymentMethodModal";
export const SYSTEM = "system";
export const CLIENT_WEB = "client-web";
export const CLIENT_MOBILE = "client-mobile";
export const SEARCH_PATH_NAMESPACE = "searchPath";
export const PAYABLE_REVIEW_NAMESPACE = "payableReview";
export const ITEM_VOIDED_ARCHIVED_NAMESPACE = "itemVoidedArchived";
export const UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE =
  "unableToLoadAmountsModal";

const namespaces = {
  COMMON_NAMESPACE,
  MENU_NAMESPACE,
  LANGUAGE_MODAL_NAMESPACE,
  ABOUT_MODAL_NAMESPACE,
  BILLER_LOGO_NAMESPACE,
  VALIDATE_NAMESPACE,
  BILL_MODAL_NAMESPACE,
  HELP_MODAL_NAMESPACE,
  BALANCE_NAMESPACE,
  CONTACT_TOC_FOOTER,
  DONATION,
  BANK_ACCCOUNT_MODAL,
  PAYABLE_DETAILS_NAMESPACE,
  CREDIT_DEBIT_MODAL,
  CASH_MODAL,
  BARCODE_VIEW,
  EMAIL_VIEW,
  SMS_VIEW,
  RETAILER_VIEW,
  PAYMENT_AMOUNT_MODAL_NAMESPACE,
  PAYMENT_METHOD_MODAL_NAMESPACE,
  REVIEW_CHARGES_MODAL_NAMESPACE,
  RECEIPT_INFO_MODAL_NAMESPACE,
  PAYMENT_RECEIPT_NAMESPACE,
  PAYSLIP_NAMESPACE,
  MANAGE_PAYMENT_METHODS_MODAL,
  UNSUBSCRIBE_ALERTS,
  LINK_EXPIRED_NAMESPACE,
  RECENT_PAYMENTS_NAMESPACE,
  SESSION_TIMEOUT,
  LOOKUP_NAMESPACE,
  FREEFORM_NAMESPACE,
  ORDER_NAMESPACE,
  LOOKUP_INFO_IMAGE_MODAL_NAMESPACE,
  PAYABLE_SELECT,
  SELECT_PAYMENT_METHOD_MODAL_NAMESPACE,
  SEARCH_PATH_NAMESPACE,
  PAYABLE_REVIEW_NAMESPACE,
  ITEM_VOIDED_ARCHIVED_NAMESPACE,
  UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE
};

export default namespaces;
